module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-shadow box-shadow--big"
  }, [_c('div', {
    staticClass: "helper__wrapper"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('TYPE_OF_IMPLANT')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row flex-center"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q10_type),
      expression: "s3q10_type"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "SILICON",
      "name": "type-of-implant"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q10_type, "SILICON")
    },
    on: {
      "change": [function($event) {
        _vm.s3q10_type = "SILICON"
      }, function($event) {
        return _vm.updateTypeLocation()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('SILICON')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q10_type),
      expression: "s3q10_type"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "SALINE",
      "name": "type-of-implant"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q10_type, "SALINE")
    },
    on: {
      "change": [function($event) {
        _vm.s3q10_type = "SALINE"
      }, function($event) {
        return _vm.updateTypeLocation()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('SALINE')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('LOCATION_OF_IMPLANT')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row flex-center"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q10_location),
      expression: "s3q10_location"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "GLAND",
      "name": "location-of-implant"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q10_location, "GLAND")
    },
    on: {
      "change": [function($event) {
        _vm.s3q10_location = "GLAND"
      }, function($event) {
        return _vm.updateTypeLocation()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('GLAND')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q10_location),
      expression: "s3q10_location"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "MUSCLE",
      "name": "location-of-implant"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q10_location, "MUSCLE")
    },
    on: {
      "change": [function($event) {
        _vm.s3q10_location = "MUSCLE"
      }, function($event) {
        return _vm.updateTypeLocation()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('MUSCLE')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af9c298","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/breast-implants.vue
// module id = 1185
// module chunks = 0